export const wsUrl = "wss://fstream.binance.com/ws/";
